import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import "./CentroAyuda.css";
import { FaWhatsapp } from 'react-icons/fa';
import { VIDEO_ID, VIDEO_URL, cargarYouTubeAPI } from "../../Modalvideoinicial/modalvideoinicial";
import { registrarEventoVideo } from "../../../services/usuarios";

const VideoRecorrido = () => {
  const location = useLocation();
  const contenedorRef = useRef(null);
  const playerRef = useRef(null);
  const yaReprodujo = useRef(false);
  const origenRef = useRef(
    location.state?.abrirVideo ? "onboarding" : "centro_ayuda"
  );

  useEffect(() => {
    let destruido = false;

    cargarYouTubeAPI().then(() => {
      if (destruido || !contenedorRef.current) return;

      playerRef.current = new window.YT.Player(contenedorRef.current, {
        videoId: VIDEO_ID,
        host: "https://www.youtube-nocookie.com",
        playerVars: { rel: 0, modestbranding: 1 },
        events: {
          onStateChange: (e) => {
            if (e.data === window.YT.PlayerState.PLAYING && !yaReprodujo.current) {
              yaReprodujo.current = true;
              registrarEventoVideo(VIDEO_URL, "reproducido", origenRef.current);
            }
            if (e.data === window.YT.PlayerState.ENDED) {
              registrarEventoVideo(VIDEO_URL, "completado");
            }
          },
        },
      });
    });

    return () => {
      destruido = true;
      if (playerRef.current && playerRef.current.destroy) {
        playerRef.current.destroy();
      }
      playerRef.current = null;
    };
  }, []);

  return (
    <div className="video-principal-wrapper">
      <div ref={contenedorRef} />
    </div>
  );
};

const sections = [
  {
  title: '0. Recorrido general de Salvir',
  recommended: true,
  content: (
    <>
      <h4>Recorrido general de Salvir</h4>

      <p>
        <strong>¿Es tu primera vez en Salvir?</strong> Te recomendamos comenzar
        con este recorrido general. En menos de cuatro minutos conocerás cómo
        configurar tu cuenta, registrar pacientes, utilizar la agenda, crear
        historias clínicas, generar recetas y dar seguimiento a tus consultas.
      </p>

      <VideoRecorrido />
      <p className="video-siguiente-paso">
        
      </p>
    </>
  ),
},
  {
    title: '1. Completa tu perfil',
    content: (
      <>
        <h4>Completa tu perfil</h4>

    <p>Este paso deja lista tu información profesional dentro de Salvir.</p>

    <p>Puedes entrar desde <strong>Configuración → Gestión de Perfil</strong>.</p>

    <p>
      Es importante que agregues tus datos completos y actualizados, tanto para apoyar el cumplimiento
      de la normativa vigente como para que tus recetas y documentos salgan con la información profesional correcta.
    </p>

    <p>
      Revisa especialmente: nombre completo, teléfono, sexo, fecha de nacimiento, dirección del consultorio,
      cédula profesional y datos de especialidad o subespecialidad si aplica.
    </p>

    <p>
      La dirección del consultorio, cédula profesional y datos de especialidad pueden aparecer en tus recetas,
      por lo que si están incompletos, la receta también puede salir incompleta.
    </p>

    <p>
      Si tienes especialidad o subespecialidad, agrega también las cédulas correspondientes.
      Esto ayuda a que tus documentos salgan con información más completa y profesional.
    </p>

    <p>
      <strong>Recomendación:</strong> antes de generar recetas reales, revisa que tu perfil esté completo
      y que los datos coincidan con los que usas en tu práctica profesional.
    </p>

   <p style={{ fontSize: "12px", color: "#64748b" }}>
  De acuerdo con los Términos y Condiciones, el usuario debe proporcionar información veraz,
  completa y actualizada. En caso de incumplimiento de los términos, Salvir podrá limitar,
  suspender o cancelar el acceso a la plataforma cuando exista una causa justificada.
</p>
      </>
    ),
  },
  {
    title: '2. Configura tu receta',
    content: (
      <>
        <h4>Configura tu receta</h4>

        <p>
          Este paso sirve para personalizar cómo se verán tus recetas dentro de Salvir.
        </p>

        <p>
          Puedes entrar desde <strong>Configuración → Receta Electrónica</strong>.
        </p>

        <p>
          Ahí puedes configurar qué datos quieres mostrar, el acomodo de la receta,
          tamaños, letras, encabezado, firma, líneas, colores, logo y otros elementos visuales.
        </p>

        <p>
          También puedes ajustar la posición de algunos elementos para que la receta se adapte
          mejor a tu formato de trabajo.
        </p>

        <p>
          <strong>Recomendación:</strong> configura tu receta antes de generar la primera receta real.
          Así evitas que después tengas que regresar a corregir detalles de presentación.
        </p>

        <p>
          La información que aparece en la receta depende en parte de lo que tengas en tu perfil.
          Por eso conviene completar primero el perfil profesional.
        </p>
      </>
    ),
  },
    {
    title: '3. Configura tu agenda, recordatorios y agendamiento en línea',
    content: (
      <>
        <h4>Configura tu agenda, recordatorios y agendamiento en línea</h4>

        <p>
          Este paso prepara tu agenda para trabajar con citas de forma más ordenada y para que tus
          pacientes puedan agendar contigo directamente.
        </p>

        <p>Puedes llegar de dos formas:</p>

        <ul>
          <li><strong>Desde Citas:</strong> entra al módulo de Citas y da clic en el engrane.</li>
          <li><strong>Desde Configuración:</strong> entra a <strong>Configuración → Agenda y recordatorios</strong>.</li>
        </ul>

        <p><strong>Horarios de atención</strong></p>

        <p>
          Define tus horarios por día. Puedes activar o desactivar cada día y agregar más de un rango
          de horario si lo necesitas, por ejemplo si atiendes en la mañana y en la tarde.
        </p>

        <p><strong>WhatsApp para citas</strong></p>

        <p>
          <strong>Confirmación:</strong> avisa al paciente cuando guardas su cita. También puedes reenviarla
          desde la cita durante las primeras horas.
        </p>

        <p>
          <strong>Recordatorio:</strong> aparece en tu panel de recordatorios un día antes de la cita, de 7:00 a 21:00.
          También puedes enviarlo desde la cita después de la confirmación, siempre que falten más de 2 horas para que inicie.
        </p>

        <p>
          Puedes editar el texto de ambos mensajes. Se pueden enviar tanto a pacientes con expediente como a
          personas pendientes de alta, siempre que tengan un celular válido. También debes tener WhatsApp
          abierto o sincronizado en el dispositivo desde el que envías.
        </p>

        <p><strong>Agendamiento en línea</strong></p>

        <p>
          Al activar la <strong>página pública de agendamiento</strong> obtienes un link para compartir con tus
          pacientes. Desde ahí podrán elegir un horario disponible y dejar sus datos. Las citas aparecen
          automáticamente en tu agenda, junto con la información que dejó cada paciente.
        </p>

        <p>
          Puedes definir la duración de cada cita, hasta cuántos días hacia adelante pueden agendar y con
          cuántas horas de anticipación mínima pueden reservar. Usa el botón <strong>Copiar mi link</strong> para
          compartirlo por WhatsApp, redes sociales o donde prefieras. Si necesitas cambiar tu link, contacta a soporte.
        </p>

        <p><strong>Ficha previa a la consulta</strong></p>

        <p>
          Si la activas, los mensajes de confirmación y recordatorio incluirán un enlace para que el paciente
          llene los datos que le falten antes de su primera consulta. Si todavía no tiene alta, se le piden todos
          sus datos; si ya la tiene, solo los que estén vacíos. Lo que envíe aparecerá en la cita como
          <strong> Ficha recibida</strong> y podrás revisarlo al completar o editar su alta.
        </p>

        <p>
          El enlace no se envía si el paciente ya tuvo su primera consulta o si sus datos ya están completos.
        </p>

        <p>
          <strong>Recomendación:</strong> no olvides dar clic en <strong>Guardar</strong> al terminar.
          Esta configuración ayuda a reducir olvidos, mejorar la asistencia y ahorrarte tiempo de captura.
        </p>
      </>
    ),
  },
  {
    title: '4. Personaliza tu cuestionario',
    content: (
      <>
        <h4>Personaliza tu cuestionario</h4>

    <p>
      Este paso te permite adaptar la forma en la que capturas la información clínica dentro de Salvir,
      según tu especialidad, tu forma de entrevistar al paciente y el nivel de detalle que necesitas documentar.
    </p>

    <p>
      Puedes entrar desde <strong>Configuración → Personalizar expediente clínico</strong>.
    </p>

    <p>
      La idea es que decidas qué tan detallada quieres que sea tu historia clínica. En algunos casos puedes
      preferir capturar un texto largo y general; en otros, puede ser más útil dividir la información en apartados
      más específicos para no olvidar nada durante la consulta.
    </p>

    <p>
      Por ejemplo, en <strong>antecedentes heredofamiliares</strong>, puedes dejar un espacio general para escribir
      todo en un solo texto, o puedes trabajar de forma más guiada separando información por familiares como
      madre, padre, hermanos, abuelos u otros familiares relevantes.
    </p>

    <p>
      Esto puede ayudarte a capturar con mayor claridad antecedentes como diabetes, hipertensión, cáncer,
      enfermedades cardiovasculares, padecimientos neurológicos, psiquiátricos u otros antecedentes familiares
      importantes.
    </p>

    <p>
      Lo mismo aplica para otras partes de la historia clínica, como <strong>antecedentes personales patológicos</strong>,
      <strong> antecedentes personales no patológicos</strong>, alergias, cirugías, hospitalizaciones,
      medicamentos actuales, hábitos, vacunación, actividad física, tabaquismo, alcohol u otros datos clínicos.
    </p>

    <p>
      También puedes ajustar la forma en la que capturas <strong>aparatos y sistemas</strong>. Puedes manejarlo como
      una revisión general en texto libre, o hacerlo más ordenado por sistema: respiratorio, cardiovascular,
      digestivo, urinario, neurológico, musculoesquelético, endocrino, piel, entre otros.
    </p>

        <p><strong>Plantillas rápidas</strong></p>

    <p>
      Las plantillas rápidas te permiten guardar textos que usas con frecuencia para insertarlos en la consulta
      con un clic, en lugar de escribirlos cada vez. Son útiles para exploraciones físicas, indicaciones o
      notas que repites seguido. Puedes activarlas o desactivarlas desde la pestaña <strong>Plantillas rápidas</strong>.
    </p>

    <p><strong>Sugerencias históricas</strong></p>

    <p>
      Salvir aprende de lo que ya has capturado y te sugiere textos en algunos campos mientras escribes,
      para que captures más rápido. Esta función viene <strong>encendida por defecto</strong>. Si prefieres
      no usarla en algún campo, puedes apagarla solo para ese campo desde la pestaña
      <strong> Sugerencias históricas</strong>.
    </p>

    <p>
      Las sugerencias son solo una ayuda: revisa siempre que el texto corresponda a la consulta que estás
      registrando antes de guardar.
    </p>

    <p>
      En resumen: puedes hacer tu cuestionario más breve si quieres avanzar rápido, o más detallado si prefieres
      una captura clínica más completa y estructurada.
    </p>

    <p>
      <strong>Recomendación:</strong> configura tu cuestionario pensando en cómo consultas realmente. Si normalmente
      preguntas ciertos antecedentes, síntomas o sistemas, conviene dejarlos visibles para que Salvir te ayude
      a no omitir información importante.
    </p>

    <p>
      Este paso no bloquea el uso de Salvir. Puedes empezar con la configuración inicial y regresar después
      a ajustar el cuestionario conforme vayas usando la plataforma con pacientes reales.
    </p>      </>
    ),
  },
    {
    title: '5. Activa la versión certificada (NOM-024)',
    content: (
      <>
        <h4>Activa la versión certificada (NOM-024)</h4>

        <p>
          Salvir está certificado por la Secretaría de Salud conforme a la NOM-024. Sin embargo,
          <strong> cada usuario debe activar la versión certificada en su cuenta</strong> para que su
          expediente cumpla con lo que pide la norma, con sus propios datos y los de su consultorio.
        </p>

        <p>
          Salvir te proporciona todos los apartados que pide la NOM-024. Completarlos de forma correcta
          y activar la versión certificada te corresponde a ti como profesional de la salud.
        </p>

        <p>
          <strong>Antes de activarla:</strong> si necesitas migrar pacientes o registrar consultas anteriores
          (por ejemplo, de expedientes en papel o de otro sistema), hazlo antes de encender el switch.
          Esto no hace que esos registros queden bajo la versión certificada, pero te ayuda, porque una vez
          activada no es posible registrar consultas con más de 48 horas hacia atrás.
        </p>

        <p>Sigue estos pasos para activarla:</p>

        <ol>
          <li>Si vas a migrar pacientes o consultas anteriores, captúralos primero.</li>
          <li>Entra a <strong>Configuración → Personalizar expediente clínico</strong>.</li>
          <li>Hasta arriba verás <strong>Certificado NOM-024</strong>. Enciende el switch.</li>
          <li>
            Después entra a <strong>Configuración → Gestión de Perfil</strong> y completa la información requerida.
            Al activar la versión certificada se agregan datos nuevos, como tu <strong>CLUES</strong> y
            el <strong>tipo de personal</strong>. Llénalos antes de tu primera consulta: sin ellos, Salvir
            no te permitirá registrar consultas en la versión certificada.
            <br />
            <strong>Revísalos con cuidado:</strong> una vez llenados y registrada tu primera consulta en la
            versión certificada, por normativa ya no podrás modificar ninguno de estos datos.
          </li>
          <li>Con tu perfil completo, ya puedes registrar pacientes y consultas bajo la versión certificada.</li>
        </ol>

        <p>
          <strong>Importante:</strong> la activación no es retroactiva. Tus pacientes y expedientes anteriores
          se conservan, pero las atenciones registradas antes de activarla no quedan bajo la versión certificada.
        </p>

        <p>
          Te recomendamos acercarte a tu institución de salud o a tu asesor para que te orienten sobre
          las normas que aplican a tu práctica.
        </p>

        <p style={{ fontSize: "12px", color: "#64748b" }}>
          De acuerdo con los Términos y Condiciones, el usuario debe proporcionar información veraz,
          completa y actualizada. La activación de la versión certificada y el llenado correcto de los
          datos requeridos son responsabilidad del usuario.
        </p>
      </>
    ),
  },
  {
    title: '6. Crea tu primer paciente',
    content: (
      <>
        <h4>Crea tu primer paciente</h4>

    <p>
      Este es uno de los pasos más importantes dentro de Salvir, porque el paciente es la base para conectar
      citas, expediente clínico, consultas, recetas y seguimiento.
    </p>

    <p>
      Puedes crear un paciente desde <strong>Expedientes Clínicos → Agregar Paciente</strong>.
    </p>

      <p>
      Si necesitas avanzar rápido, puedes usar el <strong>registro express</strong>, que da de alta al paciente
      con datos mínimos, como nombre y primer apellido.
    </p>

    <p>
      Si solo quieres <strong>agendar</strong> a alguien que todavía no es tu paciente, no necesitas darlo de alta:
      puedes agendarlo directo desde Citas como persona nueva (ver paso 7).
    </p>

    <p>
      Debes completar todos los datos del paciente antes de iniciar su consulta. Si tienes activada la
      versión certificada (NOM-024), Salvir no te permitirá iniciarla con el registro incompleto.
    </p>

    <p>
      Revisa y completa datos como fecha de nacimiento, sexo, teléfono, correo si aplica, CURP, nacionalidad,
      institución de salud, estado civil, dirección y antecedentes relevantes.
    </p>

    <p>
      <strong>Muy importante:</strong> captura correctamente el número de celular del paciente. Si el teléfono
      está incompleto, mal escrito o no corresponde a un celular válido, no podrás enviar confirmaciones ni
      recordatorios por WhatsApp aunque tengas activada esa función.
    </p>

    <p>
      Por eso, si vas a usar agenda, confirmaciones o recordatorios, asegúrate de revisar el teléfono antes
      de la cita. Es uno de los datos operativos más importantes para que el flujo funcione bien.
    </p>

    <p>
      Si necesitas completar o corregir información después del registro inicial, puedes hacerlo desde
      <strong> Expedientes Clínicos</strong>: entra al expediente del paciente, abre su <strong>ficha</strong>
      y edita los datos necesarios.
    </p>

    <p>
      Esto es especialmente importante si primero usaste registro express y después necesitas completar la
      información antes de la cita o antes de iniciar la consulta.
    </p>

    <p>
      Después de crear al paciente, podrás vincularlo con citas, iniciar su expediente clínico, registrar
      consultas de seguimiento y generar recetas cuando corresponda.
    </p>
      </>
    ),
  },
    {
    title: '7. Agenda tu primera cita',
    content: (
      <>
        <h4>Agenda tu primera cita</h4>

        <p>
          El módulo de <strong>Citas</strong> organiza tu agenda dentro de Salvir. Puedes revisar tus citas en
          vista de <strong>día, semana o mes</strong>, según como prefieras trabajar.
        </p>

        <p>
          Puedes crear una cita desde <strong>Citas → Nueva Cita</strong> o seleccionando un espacio disponible
          dentro del calendario.
        </p>

        <p><strong>¿A quién puedes agendar?</strong></p>

        <ul>
          <li>
            <strong>Un paciente que ya tiene expediente:</strong> búscalo y selecciónalo. La cita queda ligada
            a su expediente.
          </li>
          <li>
            <strong>Una persona nueva:</strong> si alguien te pide cita por teléfono o WhatsApp, puedes agendarla
            solo con su nombre y un dato de contacto, sin crear expediente todavía. Queda en tu agenda como
            <strong> pendiente de alta</strong>.
          </li>
          <li>
            <strong>Una cita personal:</strong> para bloquear tiempo en tu agenda que no es con un paciente,
            por ejemplo una junta o un pendiente.
          </li>
        </ul>

        <p>
          Si activaste el <strong>agendamiento en línea</strong> (ver paso 3), las citas que tus pacientes agenden
          desde tu link también aparecen aquí, con los datos que dejaron.
        </p>

        <p><strong>Personas pendientes de alta</strong></p>

        <p>
          Las personas agendadas sin expediente no aparecen en Expedientes Clínicos hasta que completes su alta.
          Cuando llegue su cita y des clic en <strong>Iniciar Consulta</strong>, Salvir te llevará a darlas de alta
          con los datos que ya tienes prellenados. Si el paciente llenó la <strong>ficha previa</strong>, podrás
          revisar esa información al registrarlo.
        </p>

        <p>
          Desde <strong>Personas de mi agenda</strong> puedes revisar a las personas que has agendado, corregir
          sus datos, archivarlas y juntar registros duplicados, por ejemplo si una misma persona quedó agendada dos veces.
        </p>

        <p><strong>Iniciar consulta desde la agenda</strong></p>

        <p>
          Cuando la cita es del día actual, puedes usar <strong>Iniciar Consulta</strong> directamente desde Citas.
          Salvir detecta si el paciente necesita alta, historia clínica inicial o consulta de seguimiento.
        </p>

        <p><strong>Confirmaciones y recordatorios</strong></p>

        <p>
          Si los activaste en el paso 3, al guardar la cita podrás enviar la confirmación por WhatsApp, y
          después el recordatorio desde tu panel o desde la misma cita.
        </p>

        <p>
          <strong>Recomendación:</strong> evita eliminar citas que sí representaron actividad real. Es mejor
          cancelarlas o marcarlas según su estado, porque borrarlas afecta la lectura de tus indicadores.
        </p>
      </>
    ),
  },
  {
    title: '8. Crea tu primer expediente',
    content: (
      <>
       <h4>Crea tu primer expediente</h4>

    <p>
      El expediente clínico es la parte medular de Salvir. Aquí se concentra la información médica del paciente:
      historia clínica inicial, consultas de seguimiento, antecedentes, diagnósticos, tratamientos, evolución,
      archivos clínicos y recetas relacionadas.
    </p>

    <p>
      Puedes iniciar desde <strong>Expedientes Clínicos → Iniciar Consulta</strong>. También puedes iniciar
      consulta desde una cita vinculada a un paciente.
    </p>

    <p>
      Salvir detecta automáticamente si el paciente todavía necesita una <strong>historia clínica inicial</strong>
      o si ya corresponde crear una <strong>consulta de seguimiento</strong>.
    </p>

    <p>
      En la historia clínica inicial puedes capturar información como antecedentes, motivo de consulta,
      padecimiento actual, signos vitales, exploración física, laboratorios, diagnósticos, tratamiento,
      indicaciones y próxima cita si aplica.
    </p>

    <p>
      Algunas partes del expediente, como antecedentes o información general del paciente, pueden seguirse
      completando después si surge nueva información. Por ejemplo, si después recuerdas o detectas antecedentes
      familiares, personales, alergias, hábitos u otros datos relevantes, puedes agregarlos o actualizarlos desde
      el expediente.
    </p>

    <p>
      Para hacerlo, entra a <strong>Ver Expediente</strong> desde Expedientes Clínicos. Ahí podrás consultar la
      ficha del paciente y completar o corregir la información que siga pendiente.
    </p>

    <p>
      También puedes guardar archivos relacionados con el paciente para complementar su expediente. Estos archivos
      pueden subirse durante la consulta o después, según tu forma de trabajo. Puedes usarlos para conservar
      laboratorios, estudios, documentos, imágenes clínicas u otros archivos relevantes.
    </p>

    <p>
      <strong>Importante:</strong> los datos específicos de cada consulta médica deben capturarse con cuidado antes
      de guardar. Por normativa vigente y buenas prácticas clínicas, la información propia de una consulta no debe
      modificarse libremente después de guardarse.
    </p>

    <p>
      Registra cada consulta el mismo día en que atiendes al paciente. Si tienes activada la versión
      certificada (NOM-024), Salvir no te permitirá registrar consultas con más de 48 horas hacia atrás.
    </p>

    <p>
      Esto no significa que todo el expediente quede cerrado. Información como antecedentes, datos generales,
      archivos o información complementaria del paciente puede seguirse completando cuando sea necesario.
    </p>

    <p>
      Es especialmente importante llenar correctamente los <strong>diagnósticos</strong> y <strong>tratamientos</strong>,
      porque esa información puede utilizarse después para prellenar la receta y hacer el proceso mucho más rápido
      y automático.
    </p>

    <p>
      Si capturas bien la consulta, después podrás generar recetas con menos pasos, consultar el historial completo
      del paciente y dar seguimiento clínico de forma más ordenada.
    </p>

    <p>
      <strong>Recomendación:</strong> antes de guardar una consulta, revisa diagnóstico, tratamiento, indicaciones,
      signos vitales y notas clínicas. Esa parte es la que debe quedar más cuidada desde el inicio.
    </p>
      </>
    ),
  },
  {
    title: '9. Genera tu primera receta',
    content: (
      <>
        <h4>Genera tu primera receta</h4>

    <p>
      Este paso te permite generar recetas a partir de la información clínica que ya capturaste en el expediente.
    </p>

    <p>
      Entra a <strong>Recetas Electrónicas → Crear Nueva Receta</strong>.
    </p>

    <p>
      Primero selecciona al paciente y después la consulta correspondiente. Si llenaste correctamente el
      diagnóstico, tratamiento e indicaciones durante la consulta, Salvir puede traer esa información para
      ayudarte a prellenar la receta de forma más rápida.
    </p>

    <p>
      Esto es especialmente útil porque evita capturar dos veces la misma información y reduce errores al momento
      de generar la receta.
    </p>

    <p>
      Desde <strong>Configuración → Receta Electrónica</strong> puedes definir qué información quieres mostrar
      en tus recetas y qué elementos prefieres ocultar o ajustar, como datos del médico, cédulas, dirección,
      firma, logo, diagnóstico, tratamiento u otros elementos del formato.
    </p>

    <p>
      Aunque la receta se prellene con información de la consulta, puedes revisar y ajustar el contenido antes
      de guardarla si necesitas hacer alguna modificación específica para ese documento.
    </p>

    <p>
      <strong>Muy importante:</strong> para que la receta quede registrada dentro de Salvir, debes guardarla.
      Si únicamente la exportas o la imprimes sin guardarla, la receta no quedará almacenada en el expediente
      del paciente.
    </p>

    <p>
      Guardar la receta te permite conservar el detalle, consultarla después desde el expediente del paciente
      y mantener un historial más completo de la atención.
    </p>

    <p>
      <strong>Recomendación:</strong> antes de usar recetas con pacientes reales, genera una receta de prueba
      para revisar que el diseño, firma, logo, cédula, dirección y contenido clínico aparezcan correctamente.
    </p>
      </>
    ),
  },
  {
    title: '10. Activa tu suscripción',
    content: (
      <>
        <h4>Activa tu suscripción</h4>

        <p>
          Este paso sirve para mantener activo tu acceso a Salvir cuando termine la prueba gratuita.
        </p>

        <p>
          Puedes entrar desde <strong>Configuración → Métodos de Pago</strong>.
        </p>

        <p>
          Ahí puedes agregar o gestionar tu método de pago, revisar tu plan,
          pagos realizados y fechas de renovación.
        </p>

        <p>
          Si prefieres otra opción de pago, también puedes contactar a soporte para revisar alternativas disponibles.
        </p>

        <p>
          Las facturas deben solicitarse por correo a <strong>contacto@salvir.com</strong> por el momento.
        </p>

        <p>
          <strong>Importante:</strong> mantener tu suscripción activa evita interrupciones en el acceso
          a tus herramientas de expediente, agenda y recetas.
        </p>
      </>
    ),
  },
  {
    title: 'Revisa tus indicadores',
    content: (
      <>
        <h4>Revisa tus indicadores</h4>

    <p>
      El módulo de <strong>Indicadores</strong> te ayuda a entender cómo se está moviendo tu consulta
      y si tu operación va mejorando con el tiempo.
    </p>

    <p>
      Puedes entrar desde <strong>Indicadores</strong> o desde el botón de acceso rápido en el dashboard principal.
    </p>

    <p>
      Aquí puedes revisar métricas agregadas de tu consultorio, como pacientes registrados,
      consultas atendidas, citas agendadas, tipos de pacientes y actividad por periodo.
    </p>

    <p>
      Por ejemplo, puedes ver cuántos pacientes nuevos estás registrando, cuántos pacientes regresan,
      cuántas consultas estás atendiendo durante el mes y cómo se está comportando tu agenda.
    </p>

    <p>
      También te ayuda a responder preguntas prácticas de operación, como:
    </p>

    <ul>
      <li>¿Estoy registrando más pacientes que antes?</li>
      <li>¿Mis pacientes están regresando o solo vienen una vez?</li>
      <li>¿Cuántas consultas estoy atendiendo realmente?</li>
      <li>¿Mi agenda está teniendo suficiente movimiento?</li>
      <li>¿Qué tanto estoy usando Salvir para llevar mi operación diaria?</li>
    </ul>

    <p>
      Estas métricas sirven para detectar patrones. Por ejemplo, si tienes muchos pacientes registrados pero pocas
      consultas, puede significar que estás dando de alta pacientes pero no estás completando su expediente.
      Si tienes muchas citas pero pocas consultas registradas, puede ser señal de que falta iniciar consulta desde
      la agenda o desde Expedientes Clínicos.
    </p>

    <p>
      También es importante mantener actualizada la información del sistema. Si eliminas citas que sí representaron
      actividad real, o si no registras consultas después de atender pacientes, tus indicadores pueden perder valor
      y reflejar una operación distinta a la realidad.
    </p>

    <p>
      <strong>Recomendación:</strong> revisa tus indicadores de forma periódica para entender si tu consulta está
      creciendo, si tus pacientes están regresando y si estás usando correctamente agenda, expedientes y recetas.
    </p>

    <p>
      Los indicadores no sustituyen el expediente clínico ni la revisión individual de cada paciente; sirven como
      una vista general para tomar mejores decisiones sobre tu operación.
    </p>
      </>
    ),
  },
  {
  title: 'Exporta tu información',
  content: (
    <>
      <h4>Exporta tu información</h4>

      <p>
        Salvir te permite exportar la información de tus expedientes cuando lo necesites.
      </p>

      <p>
        Para exportar un expediente, entra a <strong>Expedientes Clínicos</strong>, abre el paciente en
        <strong> Ver Expediente</strong> y usa el botón <strong>Exportar expediente</strong>.
      </p>

      <p>
        Desde ahí puedes exportar el expediente completo o seleccionar una consulta específica,
        por ejemplo una consulta de seguimiento, si solo necesitas ese registro.
      </p>

      <p>
        También puedes generar la <strong>hoja diaria</strong>. Para hacerlo, entra a
        <strong> Expedientes Clínicos</strong>, da clic en el <strong>engrane</strong> y selecciona
        <strong> Exportar hoja diaria</strong>.
      </p>

      <p>
        En la hoja diaria selecciona el rango de fechas que quieres incluir. Por rendimiento, el rango máximo
        permitido es de <strong>3 meses</strong> por exportación.
      </p>

      <p>
        <strong>Recomendación:</strong> revisa que la información esté completa antes de exportar.
        Los PDFs se generan con los datos capturados hasta ese momento.
      </p>
    </>
  ),
},
];

const CentroAyuda = () => {
  const location = useLocation();
  const [openIndex, setOpenIndex] = useState(
    location.state?.abrirVideo ? 0 : null
  );
  const [busquedaAyuda, setBusquedaAyuda] = useState("");
  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

 const normalizarTexto = (texto) =>
  String(texto || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const extraerTexto = (node) => {
  if (node === null || node === undefined || typeof node === "boolean") return "";

  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }

  if (Array.isArray(node)) {
    return node.map(extraerTexto).join(" ");
  }

  if (React.isValidElement(node)) {
    return extraerTexto(node.props.children);
  }

  return "";
};

const resaltarTexto = (texto, termino) => {
  if (!termino) return texto;

  const textoString = String(texto);
  const terminoNormalizado = normalizarTexto(termino);

  if (!terminoNormalizado) return textoString;

  const partes = [];
  let buffer = "";
  let i = 0;

  while (i < textoString.length) {
    const fragmento = textoString.slice(i, i + termino.length);

    if (normalizarTexto(fragmento) === terminoNormalizado) {
      if (buffer) {
        partes.push(buffer);
        buffer = "";
      }

      partes.push(
        <mark className="ayuda-highlight" key={`${textoString}-${i}`}>
          {textoString.slice(i, i + termino.length)}
        </mark>
      );

      i += termino.length;
    } else {
      buffer += textoString[i];
      i += 1;
    }
  }

  if (buffer) partes.push(buffer);

  return partes;
};

const resaltarContenido = (node, termino) => {
  if (!termino) return node;

  if (typeof node === "string" || typeof node === "number") {
    return resaltarTexto(node, termino);
  }

  if (Array.isArray(node)) {
    return node.map((child, index) => (
      <React.Fragment key={index}>
        {resaltarContenido(child, termino)}
      </React.Fragment>
    ));
  }

  if (React.isValidElement(node)) {
    return React.cloneElement(
      node,
      node.props,
      resaltarContenido(node.props.children, termino)
    );
  }

  return node;
};

const textoBusqueda = busquedaAyuda.trim();

const sectionsFiltradas = sections.filter((section) => {
  if (!textoBusqueda) return true;

  const textoSeccion = `${section.title} ${extraerTexto(section.content)}`;

  return normalizarTexto(textoSeccion).includes(normalizarTexto(textoBusqueda));
});

  return (
    <div className="centro-ayuda">
      <h2>Centro de Ayuda Salvir</h2>
      {/*<div className="video-principal">
         Aquí podrías insertar un iframe o componente de video 
        <p>🎥 Video principal: Cómo usar SALVIR desde el alta del paciente hasta tu primera receta</p>
      </div>*/}
    <div className="ayuda-hero">
  <div>
    
    <h3>Encuentra rápido cómo usar Salvir en tu consulta</h3>
     <p>
      Consulta guías prácticas para configurar tu perfil, activar la versión certificada, usar tu agenda
      y el agendamiento en línea, crear pacientes, completar expedientes, generar recetas y revisar tus indicadores.
    </p>
    <p>
      Si estás empezando, sigue los pasos en orden. Si ya usas Salvir, busca directamente
      el tema que necesitas resolver.
    </p>
  </div>
</div>

<div className="centro-ayuda-buscador">
  <input
    type="text"
    placeholder="Buscar por tema: receta, WhatsApp, link, NOM-024, paciente, expediente..."
    value={busquedaAyuda}
    onChange={(e) => {
      setBusquedaAyuda(e.target.value);
      setOpenIndex(null);
    }}
  />

  {textoBusqueda && (
    <p className="centro-ayuda-resultados">
      {sectionsFiltradas.length === 1
        ? `1 resultado para “${textoBusqueda}”`
        : `${sectionsFiltradas.length} resultados para “${textoBusqueda}”`}
    </p>
  )}
</div>
     {sectionsFiltradas.map((section, index) => {
  const estaBuscando = textoBusqueda.length > 0;
  const estaAbierta = estaBuscando || openIndex === index;

  return (
    <div
      key={section.title}
      className={`section ${estaAbierta ? "section-open" : ""}`}
    >
      <div
        className="section-header"
        onClick={() => toggleSection(index)}
        style={{ cursor: "pointer", fontWeight: "bold" }}
      >
        <span>{resaltarContenido(section.title, textoBusqueda)}</span>
        <span className="section-chevron">{estaAbierta ? "˅" : "›"}</span>
      </div>

      {estaAbierta && (
        <div className="section-content">
          {resaltarContenido(section.content, textoBusqueda)}
        </div>
      )}
    </div>
  );
})}
      {sectionsFiltradas.length === 0 && (
  <p className="centro-ayuda-sin-resultados">
    No encontramos resultados para tu búsqueda. Intenta con otro término como “receta”, “cita”, “paciente”, “expediente” o “indicadores”.
  </p>
)}

      <div className="soporte">
        <p>
          ¿Tienes dudas sobre cómo usar SALVIR?  
          Escríbenos por <strong>WhatsApp</strong>, con gusto te ayudamos.  
          Ofrecemos atención personalizada porque sabemos que tu tiempo es valioso.
        </p>

        <a
          href="https://wa.me/5215644811995"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-icon2"
        >
          <FaWhatsapp />
        </a>

        <p>
          ¿Hay algo que te gustaría cambiar o agregar en la plataforma?  
          ¿Tienes alguna sugerencia o idea para mejorar?  
          Nos encantará leerte en <a href="mailto:contacto@salvir.com">contacto@salvir.com</a>.  
          Revisamos cada mensaje con atención, aunque el correo puede tomar un poco más de tiempo en ser respondido.
        </p>

        <p style={{ fontSize: "17px", fontStyle: "italic" }}>
          Estamos aquí para acompañarte. Tu experiencia y tu opinión son muy importantes para nosotros.
        </p>
      </div>

    </div>
  );
};

export default CentroAyuda;